<template>
    <v-navigation-drawer
        mobile-breakpoint="1380"
        width="250"
        class="primary"
        dark
        v-model="drawer"
        app
    >
        <v-list-item
            class="primary"
            :class="miniVariant ? 'mini-variant-logo' : ''"
        >
            <v-list-item-avatar
                size="47"
                v-if="!miniVariant"
            >
                <img
                    src="/static/life_fav.png"
                    alt="LOGO"
                >
            </v-list-item-avatar>
            <v-list-item-content v-if="!miniVariant">
                <v-list-item-title>
                    {{ applicationName }} <sup class="sub-caption">TM</sup>
                </v-list-item-title>
            </v-list-item-content>
<!--            <v-list-item-action>-->
<!--                <v-btn-->
<!--                    icon-->
<!--                    @click.stop="miniVariant = !miniVariant"-->
<!--                >-->
<!--                    <v-icon v-html="miniVariant ? '$mdiChevronRight' : '$mdiChevronLeft'"></v-icon>-->
<!--                </v-btn>-->
<!--            </v-list-item-action>-->
        </v-list-item>
        <v-divider></v-divider>

        <v-list
            dense
            subheader
            :key="refresh"
            class="primary"
        >
            <template
                v-for="(menuItem, index) in menu"
                v-if="menuItem.restriction == 'none' || hasPermission(menuItem.restriction)"
            >
                <template
                    v-if="typeof menuItem.children == 'undefined'"
                >
                    <template v-if="miniVariant">
                        <v-tooltip
                            right
                            :key="'minivariant-collapse-single-' + index + '-' + key"
                        >
                            <template v-slot:activator="{ on }">
                                <v-list-item
                                    @click="menuItemClick(menuItem)"
                                    exact
                                    v-on="on"
                                    :class="activeMenuItem(menuItem) ? 'background--text v-list-item--active' : 'background--text'"
                                >
                                    <v-list-item-action>
                                        <v-icon>{{ menuItem.icon }}</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>{{ menuItem.name }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>
                            <span>
                                {{ menuItem.name }}
                            </span>
                        </v-tooltip>
                    </template>
                    <template v-else>
                        <v-list-item
                            @click="menuItemClick(menuItem)"
                            exact
                            :key="'non-minivariant-collapse-single-' + index + '-' + key"
                            v-if="!menuItem.restriction || menuItem.restriction == 'none' || hasPermission(menuItem.restriction)"
                            :class="activeMenuItem(menuItem) ? 'background--text v-list-item--active' : 'background--text'"
                        >
                            <v-list-item-action>
                                <v-icon>{{ menuItem.icon }}</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>{{ menuItem.name }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </template>
                </template>
                <template
                    v-else-if="typeof menuItem.collapsible !== 'undefined' && menuItem.collapsible"
                >
                    <template v-if="miniVariant">
                        <v-tooltip
                            right
                            v-for="(menuChild, childIndex) in menuItem.children"
                            :key="'minivariant-collapse-' + childIndex + '-' + index + '-' + key"
                        >
                            <template v-slot:activator="{ on }">
                                <v-list-item
                                    @click="menuItemClick(menuChild)"
                                    exact
                                    v-on="on"
                                    :class="activeMenuItem(menuChild) ? 'background--text v-list-item--active' : 'background--text'"
                                >
                                    <v-list-item-action>
                                        <v-icon>{{ menuChild.icon }}</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>{{ menuChild.name }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>
                            <span
                                v-if="menuChild.miniName"
                            >
                                {{ menuItem.heading }} - {{ menuChild.miniName }}
                            </span>
                            <span v-else>
                                {{ menuItem.heading }} - {{ menuChild.name }}
                            </span>
                        </v-tooltip>
                    </template>
                    <template v-else>
                        <v-list-group
                            :value="mustOpen(menuItem)"
                            @click="setActiveExpansionPanel(menuItem.heading)"
                        >
                            <template v-slot:activator>
                                <v-list-item>
                                    <v-list-item-title>{{ menuItem.heading.toUpperCase() }}</v-list-item-title>
                                </v-list-item>
                            </template>
                            <v-list-item
                                @click="menuItemClick(menuChild)"
                                exact
                                v-for="(menuChild, childIndex) in menuItem.children"
                                :key="'non-minivariant-collapse-' + childIndex + '-' + key"
                                v-if="!menuChild.restriction || menuChild.restriction == 'none' || hasPermission(menuChild.restriction)"
                                :class="activeMenuItem(menuChild) ? 'background--text v-list-item--active' : 'background--text'"
                            >
                                <v-list-item-action>
                                    <v-icon>{{ menuChild.icon }}</v-icon>
                                </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title>{{ menuChild.name }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-group>
                    </template>
                </template>
                <template v-else>
                    <v-list-item
                        v-if="!miniVariant"
                    >
                        <v-list-item-title>{{ menuItem.heading.toUpperCase() }}</v-list-item-title>
                    </v-list-item>

                    <v-tooltip
                        right
                        :disabled="!miniVariant"
                        v-for="(menuChild, childIndex) in menuItem.children"
                        :key="'collapse-' + index + '-' + childIndex + '-' + key"
                        v-if="!menuChild.restriction || menuChild.restriction == 'none' || hasPermission(menuChild.restriction)"
                    >
                        <template v-slot:activator="{ on }">
                            <v-list-item
                                @click="menuItemClick(menuChild)"
                                exact
                                v-on="on"
                                :class="activeMenuItem(menuChild) ? 'background--text v-list-item--active' : 'background--text'"
                            >
                                <v-list-item-action>
                                    <v-icon>{{ menuChild.icon }}</v-icon>
                                </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title>{{ menuChild.name }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                        <span
                            v-if="miniVariant && typeof menuChild.miniName !== 'undefined'"
                        >
                            {{ menuChild.miniName }}
                        </span>
                        <span v-else>
                            {{ menuChild.name }}
                        </span>
                    </v-tooltip>
                </template>
                <v-divider></v-divider>
            </template>
        </v-list>
    </v-navigation-drawer>
</template>
<script>
    import menu from './../configuration/menu.json';

    export default {
        name: 'Menu',
        data() {
            return {
                menu: menu,

                openPanel: null,

                icon: null,

                refresh: false,

                key: true,
            }
        },
        computed: {
            miniVariant: {
                set(value) {
                    this.$store.commit('application/setMiniVariantStatus', value);
                    this.refresh = !this.refresh;
                },
                get() {
                    return false;
                    return this.$store.getters['application/getMiniVariantStatus'];
                }
            },
            drawer: {
                set(value) {
                    this.$store.commit('application/setDrawerStatus', value);
                },
                get() {
                    return this.$store.getters['application/getDrawerStatus'];
                }
            },
            applicationName() {
                return this.$store.getters['application/getName'];
            }
        },

        methods: {
            hasPermission(permissionString) {
                if (typeof permissionString == 'undefined') {
                    return true;
                }

                let roles = permissionString.split('|');

                for (let i = 0, len = roles.length; i < len; i++) {
                    let role = roles[i];

                    if (this.hasRole(role)) {
                        return true;
                    }
                }

                return false;
            },

            setActiveExpansionPanel(name) {
                if (this.openPanel === name) {
                    this.openPanel = null;
                } else {
                    this.openPanel = name;
                }
            },

            mustOpen(item) {
                for (let i = 0, len = item.children.length; i < len; i++) {
                    let child = item.children[i];

                    let childUrl = '#';

                    if (typeof child.path !== 'undefined') {
                        childUrl = child.path;
                    }

                    if (childUrl === '/') {
                        continue;
                    }

                    if (childUrl.indexOf('?') !== -1) {
                        childUrl = child.path.substring(0, child.path.indexOf("?"));
                    }

                    if (window.location.href.indexOf(childUrl) > -1) {
                        return true;
                    }
                }
                return false;
            },

            activeMenuItem(item) {
                let itemUrl = '#';

                if (typeof item.path !== 'undefined') {
                    itemUrl = item.path;
                }

                if (itemUrl.indexOf('?') !== -1) {
                    itemUrl = item.path.substring(0, item.path.indexOf("?"));
                }

                return window.location.href.indexOf(itemUrl) > -1;
            },

            menuItemClick(item) {
                if (typeof item.target !== 'undefined') {

                    if (typeof item.newTab !== 'undefined' && item.newTab) {
                        window.open(item.target, '_blank');
                    } else {
                        window.location = item.target;
                    }
                }

                this.$router.push(item.path);

                this.key = !this.key;
            }
        }
    }
</script>
